<template>
  <div class="withdraw-password-page">
    <CustomHeader
      :text="$t('withdrawPasswordSuccess.title')"
      :is-popup-close-back-icon="false"
      @close-popup="backNavigate"
      :show-fund="false"
      @go-to-fund="goToFund"
    />

    <div class="success_container">
      
      <!-- Success Icon -->
      <div class="icon_wrapper">
        <div class="success_icon">✔</div>
      </div>

      <!-- Title -->
      <div class="success_title">
        {{ $t('withdrawPasswordSuccess.successTitle') }}
      </div>

      <!-- Description -->
      <div class="success_desc">
        {{ $t('withdrawPasswordSuccess.successDesc') }}
      </div>

      <!-- Buttons -->
      <div class="btn_group">
        <div class="btn primary" @click="goHome">
          {{ $t('withdrawPasswordSuccess.backHome') }}
        </div>

        <div class="btn secondary" @click="goWithdraw">
          {{ $t('withdrawPasswordSuccess.continueWithdraw') }}
        </div>
      </div>

    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'

import CustomHeader from '../components/common/customHeader.vue'
import MainButton from '../../themeThree/components/common/mainButton.vue'

const router = useRouter()
const userStore = useUserStore()


const backNavigate = () => {
  userStore.setRechargeBonusType(0)
  userStore.setTakeFirstDeposit(false)
  router.go(-1)
}

const goToFund = () => {
  router.replace({ path: '/fundsHistory', query: { tabIndex: 0 } })
}
const goHome = () => {
  router.replace({ path: '/' })
}

const goWithdraw = () => {
  router.replace({ path: '/sd-withdraw' })
}
</script>

<style scoped>

.withdraw-password-page{
  min-height:100vh;
  background:rgb(11, 17, 33);
  color:#fff;
}

.success_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  padding: 40px 20px;
  margin-top: 60px;
}

/* Icon */
.icon_wrapper {
  margin-bottom: 20px;
}

.success_icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #2ecc71;

  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 36px;
  color: #fff;
}

/* Title */
.success_title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
}

/* Description */
.success_desc {
  font-size: 14px;
  color: #cfd7e3;
  margin-bottom: 40px;
  max-width: 300px;
}

/* Buttons */
.btn_group {
  display: flex;
  gap: 15px;
  width: 100%;
  justify-content: center;
}

.btn {
  padding: 14px 18px;
  border-radius: 10px;
  font-size: 14px;
  cursor: pointer;
  text-align: center;
  min-width: 160px;
}

/* Primary Button */
.primary {
  background: linear-gradient(180deg, #2d8cff, #1a6ed8);
  color: #fff;
}

/* Secondary Button */
.secondary {
  border: 1px solid #1C2231;
  color: #cfd7e3;
  background: transparent;
}
.secondary:hover {
  background: #1C2231;
}
</style>